import { resolveIdentifier, types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';
import { Duty } from './Duty';
import { PharmacyDetails } from './PharmacyDetails';
import { Pharmacy } from './Pharmacy';

export const DutyAssignment = types.compose(
  BaseEntity,
  types
    .model('DutyAssignment', {
      dutyAssignmentId: types.identifierNumber,
      dutyId: types.number,
      pharmacyId: types.maybe(types.number),
    })
    .views((self) => {
      return {
        get duty() {
          return resolveIdentifier(Duty, self, self.dutyId);
        },
        get pharmacyDetails() {
          if (self.pharmacyId) {
            return resolveIdentifier(PharmacyDetails, self, self.pharmacyId);
          } else {
            return null;
          }
        },
        get pharmacySimple() {
          if (self.pharmacyId) {
            return resolveIdentifier(Pharmacy, self, self.pharmacyId);
          } else {
            return null;
          }
        },
      };
    })
    .actions((self) => {
      return {};
    }),
);
